import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getNewsCategories, getNewsByCategory } from '../data/navigationData';

const NewsPage = () => {
  const categories = getNewsCategories();
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [searchTerm, setSearchTerm] = useState('');
  
  // 过滤新闻网站
  const filteredNews = getNewsByCategory(selectedCategory).filter(news => 
    news.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    news.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 处理外部链接点击
  const handleExternalLinkClick = (name, url) => {
    // 这里可以添加统计代码或其他逻辑
    console.log(`跳转到: ${name}`);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // 页面加载时滚动到顶部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="news-page">
      <div className="news-header">
        <Link to="/" className="back-home-btn">
          ← 返回首页
        </Link>
        <div className="header-content">
          <p>&nbsp;</p>
          <h1>📰 网站导航</h1>
        </div>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="搜索新闻网站..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-btn">🔍</button>
        </div>
      </div>

      <div className="news-category-tabs">
        {categories.map(category => (
          <button
            key={category}
            className={`news-category-tab ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category)}
            style={{
              backgroundColor: selectedCategory === category ? '#4A90E2' : 'white',
              color: selectedCategory === category ? 'white' : '#333'
            }}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="news-grid">
        {filteredNews.length > 0 ? (
          filteredNews.map(news => (
            <div 
              key={news.id} 
              className="news-card"
              onClick={() => handleExternalLinkClick(news.name, news.url)}
              style={{ borderTopColor: news.color }}
            >
              <div className="news-icon" style={{ color: news.color }}>
                {news.icon}
              </div>
              <div className="news-content">
                <h3 className="news-name">{news.name}</h3>
                <span className="news-category">{news.category}</span>
                <p className="news-description">{news.description}</p>
              </div>
              <div className="news-actions">
                <button className="visit-btn">
                  访问网站 →
                </button>
                <a 
                  href={news.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="direct-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  新窗口打开
                </a>
              </div>
            </div>
          ))
        ) : (
          <div className="no-results">
            <div className="no-results-icon">🔍</div>
            <h3>未找到相关新闻网站</h3>
            <p>尝试调整搜索关键词或选择其他分类</p>
          </div>
        )}
      </div>

      <div className="news-tips">
        <h3>使用提示</h3>
        <ul>
          <li>点击新闻卡片可直接访问对应网站</li>
          <li>使用分类标签快速筛选不同类型的新闻网站</li>
          <li>支持搜索功能，可通过名称或描述查找网站</li>
          <li>点击"新窗口打开"可在新标签页中打开网站</li>
        </ul>
      </div>

      <footer className="news-footer">
        <p>© 2026 新闻导航 | 收集常用新闻网站，方便快速访问</p>
        <div className="footer-links">
          <Link to="/">软件下载中心</Link> | 
          <a href="#">联系我们</a> | 
          <a href="#">隐私政策</a> | 
          <a href="#">使用条款</a>
        </div>
      </footer>
    </div>
  );
};

export default NewsPage;